import React from 'react';

import img from '../../assests/icons/finish-light.png';

export default function FinishLightIcon(props) {
    return (<img src={img} alt="" style={props.style} ref={props.refs} className="img-responsive Finish-light-icon"/>)
};